import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesSection from './components/ServicesSection';
import AIAnswerBlock from './components/AIAnswerBlock';
import ProcessSection from './components/ProcessSection';
import WhyChooseSection from './components/WhyChooseSection';
import ServiceAreasSection from './components/ServiceAreasSection';
import TestimonialsSection from './components/TestimonialsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function HomePage() {
  return (
    <div className="bg-[#0A0A0A] min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <TrustBar />
        <ServicesSection />
        <AIAnswerBlock />
        <ProcessSection />
        <WhyChooseSection />
        <ServiceAreasSection />
        <TestimonialsSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
